import {
  MetricsHighlightsClient,
  ClientOutput,
} from '../../Clients/MetricsHighlightsClient';
import { currentMembersSelector } from 'selectors/OrganizationMembers';
import { Member } from '../../../models/OrganizationMembers';
import { call, put, select } from 'redux-saga/effects';
import { ApiGetter } from '../../Clients/ApiGetter';
import { actions as reviewerActions } from '../../../reducers/ProjectDashboard/Highlights/ReviewerHighlights';
import { actions as authorActions } from '../../../reducers/ProjectDashboard/Highlights/AuthorHighlights';
import keyBy from 'lodash/keyBy';

export const metricsHighlightsClient = new MetricsHighlightsClient(
  new ApiGetter()
);

interface GetMetricsHighlightsAction {
  organizationUUID: string;
  repositoryUUID: string;
}

export function* getMetricsHighlights({
  organizationUUID,
  repositoryUUID,
}: GetMetricsHighlightsAction) {
  const { data, error }: ClientOutput = yield call(
    [metricsHighlightsClient, metricsHighlightsClient.retrieveAsync],
    { organizationUUID, repositoryUUID }
  );

  if (error || !data) {
    yield put(reviewerActions.setReviewerHighlights(undefined));
    yield put(authorActions.setAuthorHighlights(undefined));
    return;
  }

  const currentMembers: Member[] | undefined = yield select(
    currentMembersSelector
  );
  const nameToMember = keyBy(
    currentMembers,
    (member) => member.provider_account
  );

  const reviewerHighlights = data?.listNumIssuesCaughtByReviewers.map(
    (reviewer) => {
      if (reviewer.name === 'PullRequest') {
        return {
          username: reviewer.name,
          value: reviewer.value,
          src: '/favicon.ico',
        };
      }

      const member = nameToMember[reviewer.name];

      return {
        username: reviewer.name,
        value: reviewer.value,
        src: member?.user?.photo_url,
        alt: member?.user?.name,
      };
    }
  );

  const authorHighlights = data?.listPercentageTestsByAuthors.map((author) => {
    const member = nameToMember[author.name];

    return {
      username: author.name,
      value: author.value,
      src: member?.user?.photo_url,
      alt: member?.user?.name,
    };
  });

  yield put(reviewerActions.setReviewerHighlights(reviewerHighlights));
  yield put(authorActions.setAuthorHighlights(authorHighlights));
}
